<template>
  <div class="home">
    <van-pull-refresh v-model="isReLoading" @refresh="onRefresh">
      <div id="app">
        <div class="loadPage" v-if="showAllTF">
          <img src="http://file.chexun.com/chexun/statics/m/news/images/img/loading.gif" alt="" />
        </div>
        <div v-if="!cjVideoTF" :class="dropDown ? 'pullTips' : 'pullTips1'">
          {{ pulldownTxt }}
        </div>
        <div class="videoDetail-wifiTips" v-if="headType == 1 && !wifiTF">
          <div class="wifiTips-div1">
            <p class="wifiTips-p">您正在使用非WIFI网络，播放将会产生流量费用</p>
            <div class="wifiTips-div2">
              <span @click="closewifiTips(0)" class="wifiTips-span">取消</span>
              <span @click="closewifiTips(1)" class="wifiTips-span wifiTips-span1">确定</span>
            </div>
          </div>
        </div>
        <div class="app-zzSpan" @click="closezzSpan()" v-if="zzSpanTF"></div>
        <div class="videoDetail-imgCarousel" @click="closeCarouselDiv()" ref="imgCarouselDiv" v-if="imgCarouselTF">
          <!-- <div class="imgCarousel-div1" @scroll="imgCarouselScroll($event)">
          <div class="imgCarousel-div2" v-for="item in imgSrcArr" :key="item">
            <img
              ref="carouseImg"
              :class="imgHidTF ? 'imgOpacity' : ''"
              :src="item"
              alt=""
            />
          </div>
        </div> -->
          <nut-swiper ref="demo1" :loop="loopTF" :canDragging="false" :paginationVisible="false"
            :initPage="newCurrentPage">
            <div ref="ImgSwipers" class="ImgSwiper" v-for="item in imgSrcArr" :key="item">
              <img ref="carouseImg" :class="imgHidTF ? 'imgOpacity' : ''" :src="item" alt="" />
            </div>
          </nut-swiper>
        </div>
        <div class="app-span" v-if="loadingTF"></div>
        <!-- 头部类型一 -->
        <!-- <div class="videoDetail-videoHeader3" ref="videoHeader3" v-if="headType==2"></div> -->
        <div class="videoDetail-videoHeader2" ref="videoHeader2" v-if="headType == 2"></div>
        <div class="videoDetail-videoHeaderFixed" ref="videoHeaderFixed" v-if="headType == 1"></div>
        <div class="videoDetail-videoHeader" ref="videoHeaderData" v-if="headType == 1">
          <!-- <div class="videoDetail-bottomImg">
				<img src="http://file.chexun.com/chexun/statics/m/news/images/img/shade.png" alt="">
			</div> -->
          <div class="statusHeight" ref="statusHeight"></div>

          <div class="videoDetail-videoContent">
            <div class="videoContent-head">
              <div @click="goBack()" class="videoContent-div">
                <img src="http://file.chexun.com/chexun/statics/m/news/images/img/back.png" alt=""
                  class="videoContent-img" />
              </div>
              <div class="videoContent-div1" @click="goHomePage(0)">
                <span class="videoContent-span">
                  <img v-if="userInfoImgTF" src="http://m.chexun.com/statics/news/img/mrtx.847e6696.png" alt="" />
                  <img v-if="!userInfoImgTF" :src="userInfo.mcnCover" alt="" />
                </span>
                <div class="videoContent-div1-div">
                  <p>{{ userInfo.mcnName }}</p>
                  <div class="videoContent-div1-div-span">
                    <span v-if="showCount">浏览量{{ userInfo.viewCount }}
                    </span>
                    <span v-if="userInfo.userFansCount != 0">粉丝 {{ userInfo.userFansCountShow }}</span>
                  </div>
                </div>
              </div>
              <div v-if="!interestTF" @click="interest(0)" class="videoContent-div2">
                关注
              </div>
              <div v-if="interestTF" @click="interest(1)" class="videoContent-div2 videoContent-div2-other">
                已关注
              </div>
            </div>
          </div>
          <div class="videoDetail-headerContent">
            <div class="videoDetail-div3">
              <div v-if="typeData.playUrl == '' || typeData.playUrl == undefined"></div>
              <video v-else :id="'myvideo' + timestamp" webkit-playsinline="true" x-webkit-airplay="true"
                playsinline="true" x5-video-player-type="h5" x5-video-orientation="h5" x5-video-player-fullscreen="true"
                class="
                  video-js
                  vjs-big-play-centered vjs-default-skin
                  videoDetail-video
                " controls></video>
            </div>
          </div>
        </div>
        <!--  -->
        <!-- 头部类型二 -->
        <div class="videoDetail-videoHeader1" ref="videoHeader1" v-if="headType == 2">
          <div class="videoContent-head">
            <div @click="goBack()" class="videoContent-div">
              <img src="http://file.chexun.com/chexun/statics/m/news/images/img/titleback.png" alt=""
                class="videoContent-img" />
            </div>
            <div class="videoContent-div1" @click="goHomePage(0)">
              <span class="videoContent-span">
                <img v-if="userInfoImgTF" src="http://m.chexun.com/statics/news/img/mrtx.847e6696.png" alt="" />
                <img v-if="!userInfoImgTF" :src="userInfo.mcnCover" alt="" />
              </span>
              <div class="videoContent-div1-div">
                <p>{{ userInfo.mcnName }}</p>
                <div class="videoContent-div1-div-span">
                  <span v-if="showCount">浏览量{{ userInfo.viewCount }} </span>
                  <span v-if="userInfo.userFansCount != 0">粉丝 {{ userInfo.userFansCountShow }}</span>
                </div>
              </div>
            </div>
            <div v-if="!interestTF" @click="interest(0)" class="videoContent-div2">
              关注
            </div>
            <div v-if="interestTF" @click="interest(1)" class="videoContent-div2 videoContent-div2-other">
              已关注
            </div>
          </div>
        </div>
        <!--  -->
        <div :class="headType == 1
          ? 'videoDetail-videoInfo'
          : 'videoDetail-videoInfo videoDetail-videoInfo1'
          ">
          <div class="videoInfo-div">
            <h1 :class="headType == 1 ? 'videoInfo-h1' : 'videoInfo-h12'">
              {{ typeData.title }}
            </h1>
            <img v-if="headType == 1 && tbImgTF" @click="changeTBimg()" class="videoInfo-img"
              src="http://file.chexun.com/chexun/statics/m/news/images/img/path.png" alt="" />
            <img v-if="headType == 1 && !tbImgTF" @click="changeTBimg()" class="videoInfo-img"
              src="http://file.chexun.com/chexun/statics/m/news/images/img/topArrow.png" alt="" />
          </div>
          <div class="videoInfo-div3" v-if="!tbImgTF">
            <p class="videoInfo-div3-p">{{ typeData.description }}</p>
            <span class="videoInfo-div3-span">{{ typeData.createTime }}</span>
          </div>
          <div class="videoInfo-div1" v-if="typeData.keywords">
            <div class="videoInfo-topic" v-for="item in typeData.keywords" :key="item" @click="goTagPage(item)">
              <img class="topic-img" src="http://file.chexun.com/chexun/statics/m/news/images/img/topic.png" alt="" />
              <span class="topic-span">{{ item }}</span>
            </div>
          </div>
          <!-- 文章类型 -->
          <div class="videoContent-articleTime" v-if="headType == 2">
            <div class="articleTime-left">
              <span>{{ typeData.month }}月{{ typeData.day }}日
                {{ typeData.hour }}:{{ typeData.minutes }}</span>
            </div>
            <div class="articleTime-right">
              <div class="articleTime-right-div" v-if="typeData.pageView != 0">
                <img class="articleTime-right-img"
                  src="http://file.chexun.com/chexun/statics/m/news/images/img/liulanqi.png" alt="" />
                <span>{{ typeData.pageViewStr }}</span>
              </div>
              <div class="articleTime-right-div" v-if="thumbsStatus == false" @click="likeArticle(0)">
                <img class="articleTime-right-img1"
                  src="http://file.chexun.com/chexun/statics/m/news/images/img/zan.png" alt="" />
                <span>{{ typeData.thumbsCounts }}</span>
              </div>
              <div class="articleTime-right-div" v-if="thumbsStatus == true" @click="likeArticle(1)">
                <img class="articleTime-right-img1"
                  src="http://file.chexun.com/chexun/statics/m/news/images/img/zanzan.png" alt="" />
                <span>{{ typeData.thumbsCounts }}</span>
              </div>
            </div>
          </div>
          <!-- @click="openCarousel(typeData.newsContent, $event)" -->
          <div class="videoContent-article" @click="openCarousel(typeData.newsContent, $event)"
            v-html="typeData.newsContent" v-if="headType == 2"></div>
          <!--  -->
          <div v-if="!cjVideoTF" :class="headType == 2
            ? 'videoInfo-div2 videoInfo-div2New'
            : 'videoInfo-div2'
            ">
            <div class="videoInfo-div2-div">
              <img class="videoInfo-div2-img" src="http://file.chexun.com/chexun/statics/m/news/images/img/liulanqi.png"
                alt="" />
              <span>{{ typeData.pageViewStr }}</span>
            </div>
            <div class="videoInfo-div2-div" v-if="thumbsStatus == false" @click="likeArticle(0)">
              <img class="videoInfo-div2-img1" src="http://file.chexun.com/chexun/statics/m/news/images/img/zan.png"
                alt="" />
              <span>{{ typeData.thumbsCounts }}</span>
            </div>
            <div class="videoInfo-div2-div" v-if="thumbsStatus == true" @click="likeArticle(1)">
              <img class="videoInfo-div2-img1" src="http://file.chexun.com/chexun/statics/m/news/images/img/zanzan.png"
                alt="" />
              <span>{{ typeData.thumbsCounts }}</span>
            </div>
            <div class="videoInfo-div2-div" @click="goComment()">
              <img class="videoInfo-div2-img1" src="http://file.chexun.com/chexun/statics/m/news/images/img/pinglun.png"
                alt="" />
              <span>评论</span>
            </div>
            <div class="videoInfo-div2-div" @click="shareUrl(true)">
              <img class="videoInfo-div2-img3" src="http://file.chexun.com/chexun/statics/m/news/images/img/share.png"
                alt="" />
              <span>分享</span>
            </div>
          </div>
        </div>
        <div class="videoDetail-data" v-if="videoList != ''">
          <div class="videoList-div" v-if="headType == 1">
            <h1>播放列表</h1>
            <img src="http://file.chexun.com/chexun/statics/m/news/images/img/more.png" alt="" @click="goHomePage(1)" />
          </div>
          <div v-if="headType == 1" class="videoList-div1">
            <figure class="videoList-figure" v-for="(item, index) in videoList" :key="item.id"
              @click="playVideo(item, index)">
              <div class="videoList-figure-div">
                <img class="videoList-figure-img" :src="item.uploadCover" alt="" />
                <div class="videoList-figure-div1">
                  <div :class="item.playing
                    ? 'videoList-figure-playing'
                    : 'videoList-figure-playing displayNone'
                    ">
                    <img class="videoList-figure-img1"
                      src="http://file.chexun.com/chexun/statics/m/news/images/img/zhibo.gif" alt="" />
                    <span>正在播放</span>
                  </div>
                  <div class="videoList-figure-time">
                    <span>{{ item.duration }}</span>
                  </div>
                </div>
              </div>
              <figcaption>
                <h1 :class="item.playing
                  ? 'videoList-figure-h1 changecolor'
                  : 'videoList-figure-h1'
                  ">
                  {{ item.title }}
                </h1>
              </figcaption>
            </figure>
          </div>
          <div class="videoList-div" v-show="cxTF && headType == 1">
            <h1>相关车系</h1>
          </div>
          <div class="videoSwiper" v-show="cxTF == true">
            <nut-swiper direction="horizontal" :loop="true" :auto-play="3000" ref="demo2" :pagination-visible="true">
              <div v-for="(item, index) in seriesIdArr" :key="item.id" class="nut-swiper-slide">
                <img v-if="item.disstate > 0" class="videoSwipe-posImg"
                  src="http://file.chexun.com/chexun/statics/m/news/images/img/ccfLogo.png" alt="" />
                <div :class="item.disstate == 0
                  ? 'videoSwipe-div videoSwipe-divWhite'
                  : 'videoSwipe-div '
                  ">
                  <figure>
                    <img class="videoSwipe-img" :src="item.seriesImg" alt="" />
                    <figcaption v-if="item.disstate > 0">
                      <h2 class="videoSwipe-h2">{{ item.brandName }}</h2>
                      <h2 class="videoSwipe-h2">{{ item.seriesName }}</h2>
                      <div class="videoSwipe-div1">
                        <span @click="goCjDepage(item)" class="videoSwipe-span">拆解详情</span>
                        <span @click="goCxpage(item.seriesId)" class="videoSwipe-span">车系页</span>
                      </div>
                    </figcaption>
                    <figcaption v-if="item.disstate == 0">
                      <h2 class="videoSwipe-h2 videoSwipe-h2New1">
                        {{ item.seriesName }}
                      </h2>
                      <h2 class="videoSwipe-h2 videoSwipe-h2New">
                        {{ item.totalPrice }}
                      </h2>
                      <div class="videoSwipe-div1">
                        <span @click="goCxpage(item.seriesId)" class="videoSwipe-span videoSwipe-spanNew">车系页</span>
                        <span @click="goXJpage(item)" class="videoSwipe-span videoSwipe-spanNew">询价</span>
                      </div>
                    </figcaption>
                  </figure>
                </div>
              </div>
            </nut-swiper>
          </div>
        </div>
        <div class="videoDetail-comment">
          <!-- 热门评论abc -->
          <div class="comment" v-if="hotComment != ''">
            <h1 class="comment-h1">热门评论</h1>
            <div v-for="item in hotComment" :key="item.id">
              <div class="comment-div">
                <div class="comment-div-left">
                  <figure>
                    <div class="comment-div-img">
                      <img :src="item.fromUserPic" alt="" />
                    </div>
                    <figcaption>
                      <span class="comment-span-name">{{
                        item.fromUserName
                      }}</span>
                      <span class="comment-span-time">{{
                        item.createTime
                      }}</span>
                    </figcaption>
                  </figure>
                </div>
                <div class="comment-div-right">
                  <div class="comment-right-div">
                    <img class="comment-right-img"
                      src="http://file.chexun.com/chexun/statics/m/news/images/img/pinglun.png" alt="" />
                    <span v-if="item.myuserId != item.fromUserId" @click="writePL(item, index)"
                      class="comment-right-span">评论</span>
                    <span v-if="item.myuserId == item.fromUserId" @click="delComment(item)"
                      class="comment-right-span">删除</span>
                  </div>
                  <div class="comment-right-div" @click="dianzan(index, item.id, item)">
                    <img v-if="!item.isLike" class="comment-right-img1"
                      src="http://file.chexun.com/chexun/statics/m/news/images/img/zan.png" alt="" />
                    <img v-if="item.isLike" class="comment-right-img1"
                      src="http://file.chexun.com/chexun/statics/m/news/images/img/dzan.png" alt="" />
                    <span class="comment-right-span">{{
                      item.thumbUpCount
                    }}</span>
                  </div>
                </div>
              </div>
              <div class="comment-div1">
                {{ item.content }}
              </div>
            </div>
          </div>
          <!-- abc -->
          <!-- 全部评论789 -->
          <h1 class="comment-h1" v-if="commentList.length != 0" ref="allCommentList">
            全部评论({{ commentList.length }})
          </h1>
          <div class="comment-allList" v-if="commentList.length != 0">
            <div :class="commentList.length > 3 && alllistTF == true
              ? 'comment-limitList'
              : ''
              ">
              <div class="comment-list" v-for="(item, index) in commentList" :key="item.id">
                <div class="comment-div">
                  <div class="comment-div-left">
                    <figure>
                      <div class="comment-div-img">
                        <img :src="item.fromUserPic" alt="" />
                      </div>
                      <figcaption>
                        <span class="comment-span-name">{{
                          item.fromUserName
                        }}</span>
                        <span class="comment-span-time">{{
                          item.createTime
                        }}</span>
                      </figcaption>
                    </figure>
                  </div>
                  <div class="comment-div-right">
                    <div class="comment-right-div">
                      <img class="comment-right-img"
                        src="http://file.chexun.com/chexun/statics/m/news/images/img/pinglun.png" alt="" />
                      <span v-if="userId != item.fromUserId" @click="writePL(item, index)"
                        class="comment-right-span">评论</span>
                      <span v-if="userId == item.fromUserId" @click="delComment(item)"
                        class="comment-right-span">删除</span>
                    </div>
                    <div class="comment-right-div" @click="dianzan(index, item.id, item)">
                      <img v-if="!item.isLike" class="comment-right-img1"
                        src="http://file.chexun.com/chexun/statics/m/news/images/img/zan.png" alt="" />
                      <img v-if="item.isLike" class="comment-right-img1"
                        src="http://file.chexun.com/chexun/statics/m/news/images/img/dzan.png" alt="" />
                      <span class="comment-right-span">{{
                        item.thumbUpCount
                      }}</span>
                    </div>
                  </div>
                </div>
                <div class="comment-div1">
                  {{ item.content }}
                </div>
                <!-- 评论回复 -->
                <!-- v-if="item.mainInfo.id!=undefined" -->
                <div class="comment-reply" v-if="item.mainInfo.id != undefined">
                  <div class="comment-div">
                    <div class="comment-div-left">
                      <figure>
                        <!-- <div class="comment-div-img">
                        <img src="" alt="" />
                      </div> -->
                        <figcaption>
                          <span class="comment-span-name">@{{ item.mainInfo.fromUserName }}：</span>
                          <div class="comment-div1">
                            {{ item.mainInfo.content }}
                          </div>
                          <!-- <span class="comment-span-time">{{item.mainInfo.createTime}}</span> -->
                        </figcaption>
                      </figure>
                    </div>
                    <div class="comment-div-right"></div>
                  </div>

                  <!-- 回复<span>@{{item.mainInfo.createTime}}</span>： -->
                  <!-- <div v-if="!item.pullTF" @click="pullReply(index,item.id)" class="comment-pullRe">
											<p>展开1条回复</p>
											<img src="http://file.chexun.com/chexun/statics/m/news/images/img/moreComment.png" alt="">
										</div>
										<div class="comment-pullcom" v-if="item.pullTF">
											<div class="comment-div">
												<div class="comment-div-left">
													<figure>
														<div class="comment-div-img">
															<img src="" alt="">
														</div>
														<figcaption>
															<span class="comment-span-name">卢丽</span>
															<span class="comment-span-time">1小时前</span>
														</figcaption>
													</figure>
												</div>
												<div class="comment-div-right"></div>
											</div>
											<div class="comment-div1">
												回复<span>@范妹</span>：拉起来一个队伍，有进有出很正常，你不喜欢有人喜欢。
											</div>
										</div>
										<div v-if="item.pullTF" @click="pullReply(index,item.id)" class="comment-pullRe">
											<p>收起</p>
										</div> -->
                </div>
              </div>
            </div>
            <div @click="clickAlllist()" v-if="alllistTF" class="comment-pullAllList">
              <div class="comment-pullRe">
                <p>展开{{ commentList.length }}条评论</p>
                <img src="http://file.chexun.com/chexun/statics/m/news/images/img/moreComment.png" alt="" />
              </div>
            </div>
          </div>
          <!-- 789 -->
        </div>
        <div class="videoDetaild-hobby">
          <h1 class="comment-h1">猜你喜欢</h1>
        </div>
        <nut-infiniteloading @loadmore="onInfinite" :is-show-mod="true" :has-more="isHasMore" :is-loading="isLoading"
          :threshold="100">
          <div class="hobbyList" v-for="(item, index) in likeList" :key="item.entityId">
            <div :class="item.entityType == 2 ||
              item.entityType == 7 ||
              item.entityType == 1
              ? 'hobbyList-div hobbyList-div1'
              : 'hobbyList-div'
              ">
              <!-- type==1 -->
              <div class="hobbyList-allType" v-if="
                item.entityType == 2 ||
                item.entityType == 7 ||
                item.entityType == 1
              " @click="goDetail(item)">
                <div class="hobbyList-div-video">
                  <div class="hobbyList-div-div">
                    <img :src="item.cover" alt="" />
                  </div>
                  <img src="http://file.chexun.com/chexun/statics/m/news/images/img/playingNow.png" alt=""
                    class="hobbyList-div-img" />
                  <span v-if="item.duration != ''" class="hobbyList-div-span">{{
                    item.duration
                  }}</span>
                </div>
                <div class="hobbyList-div-h1">
                  <h1>{{ item.title }}</h1>
                </div>
              </div>
              <!-- type==2 -->
              <div class="hobbyList-allType" v-if="item.titleType == 3" @click="goDetail(item)">
                <div class="hobbyList-div-imglist">
                  <img v-for="items in item.newsPics" :src="items" alt="" :key="items" />
                  <div class="hobbyList-div-imglist-div" v-if="item.newsPics.length == 2"></div>
                </div>
                <div class="hobbyList-div-h1">
                  <h1>{{ item.title }}</h1>
                </div>
              </div>
              <!-- type==3 -->
              <div class="hobbyList-allType" @click="goDetail(item)" v-if="
                (item.entityType == 5 && item.titleType == 0) ||
                (item.entityType == 5 && item.titleType == 1)
              ">
                <div class="allType3-div">
                  <img class="allType-img" :src="item.cover" alt="" />
                  <div class="hobbyList-div-h1">
                    <h1>{{ item.title }}</h1>
                  </div>
                </div>
              </div>

              <div class="hobbyList-div-info">
                <div class="hobbyList-info-left">
                  <figure>
                    <div class="hobbyList-info-img">
                      <img :src="item.mcnIcon" alt="" />
                    </div>
                    <figcaption>
                      <p>{{ item.mcnRealName }}</p>
                      <span>{{ item.createTime }}</span>
                    </figcaption>
                  </figure>
                </div>
                <div class="hobbyList-info-right">
                  <div class="hobbyList-right-div" v-if="item.pageView != 0">
                    <img class="hobbyList-right-img"
                      src="http://file.chexun.com/chexun/statics/m/news/images/img/liulanqi.png" alt="" />
                    <span>{{ item.pageViewStr }}</span>
                  </div>
                  <div class="hobbyList-right-div" @click="shareUrl(false, item)">
                    <img class="hobbyList-right-img1"
                      src="http://file.chexun.com/chexun/statics/m/news/images/img/share.png" alt="" />
                    <span>分享</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nut-infiniteloading>

        <div class="videoDetail-bottomTab" v-if="!cjVideoTF">
          <div class="bottomTab-left bottomTab-left1" @click="clickPinglung()">
            <div class="bottomTab-left-div">
              <img src="http://file.chexun.com/chexun/statics/m/news/images/img/edit.png" alt="" />
              <span v-if="wxTF" class="bottomTab-left-span">留下你的评论~</span>
              <input v-if="!wxTF" ref="inputFocus" v-model="pinglunValue" @blur="onRodeChange()" type="text"
                placeholder="留下你的评论~" />
            </div>
          </div>
          <div class="bottomTab-right" v-if="!pinglunTF">
            <div class="bottomTab-right-div" v-if="cxTF" @click="openCxTag()">
              <img class="bottomTab-right-img" src="http://file.chexun.com/chexun/statics/m/news/images/img/chexi.png"
                alt="" />
              <p>车系</p>
            </div>
            <div class="bottomTab-right-div" @click="goComment()">
              <img v-if="commentList.length != 0" class="bottomTab-right-img1"
                src="http://file.chexun.com/chexun/statics/m/news/images/img/pinglun1.png" alt="" />
              <img v-else class="bottomTab-right-img1"
                src="http://file.chexun.com/chexun/statics/m/news/images/img/pinglunbottom.png" alt="" />
              <p>评论</p>
              <span v-if="commentList.length != 0">{{
                commentList.length
              }}</span>
            </div>
            <div class="bottomTab-right-div" v-if="thumbsStatus == false" @click="likeArticle(0)">
              <img class="bottomTab-right-img2" src="http://file.chexun.com/chexun/statics/m/news/images/img/zanbt.png"
                alt="" />
              <p>喜欢</p>
            </div>
            <div class="bottomTab-right-div" v-if="thumbsStatus == true" @click="likeArticle(1)">
              <img class="bottomTab-right-img2" src="http://file.chexun.com/chexun/statics/m/news/images/img/zanzan.png"
                alt="" />
              <p>喜欢</p>
            </div>
            <div class="bottomTab-right-div" @click="shareUrl(true)">
              <img class="bottomTab-right-img3"
                src="http://file.chexun.com/chexun/statics/m/news/images/img/fenxiang.png" alt="" />
              <p>分享</p>
            </div>
          </div>
          <div v-if="pinglunTF">
            <div @click="submitPinglun()" v-if="!subPLTF" class="bottomTab-right1">
              <span>发送</span>
            </div>
            <div v-if="subPLTF" class="bottomTab-right1">
              <span>发送</span>
            </div>
          </div>
        </div>

        <div class="downLoadApp" v-if="downLoadTF">
          <div class="downLoadApp-left">
            <img class="downLoadApp-img" src="http://file.chexun.com/chexun/statics/m/news/images/img/cxwlogoimg.png"
              alt="" />
            <div class="downLoadApp-left-div">
              <img class="downLoadApp-img1"
                src="http://file.chexun.com/chexun/statics/m/news/images/img/cxwlogofont.png" alt="" />
              <p>拆得专业 选得简单 买得靠谱 >></p>
            </div>
          </div>
          <div class="downLoadApp-right">
            <div class="downLoadApp-right-div" @click="goDownLoadApp()">
              App下载
            </div>
            <img @click="closeDown()" src="http://file.chexun.com/chexun/statics/m/news/images/img/close1.png" alt=""
              class="downLoadApp-right-img" />
          </div>
        </div>
      </div>
      <div class="cxTag1" @click="closeCxTag()" v-if="seriesTF"></div>
      <div class="cxTag" v-if="seriesTF">
        <div class="cxTag-content">
          <div class="cxTag-div">
            <h1>相关车系 ({{ seriesIdArr.length }})</h1>
            <img @click="closeCxTag()" src="http://file.chexun.com/chexun/statics/m/news/images/img/close1.png"
              alt="" />
          </div>
          <div class="cxTag-div1" v-if="seriesCjTF">
            <nut-swiper direction="horizontal" ref="demo2" :pagination-visible="true">
              <div v-for="(item, index) in seriesCjArr" :key="item.id" class="nut-swiper-slide">
                <img class="videoSwipe-posImg" src="http://file.chexun.com/chexun/statics/m/news/images/img/ccfLogo.png"
                  alt="" />
                <div class="videoSwipe-div">
                  <figure>
                    <img class="videoSwipe-img" :src="item.seriesImg" alt="" />
                    <figcaption>
                      <h2 class="videoSwipe-h2">{{ item.brandName }}</h2>
                      <h2 class="videoSwipe-h2">{{ item.seriesName }}</h2>
                      <div class="videoSwipe-div1">
                        <span @click="goCjDepage(item)" class="videoSwipe-span">拆解详情</span>
                        <span @click="goCxpage(item.seriesId)" class="videoSwipe-span">车系页</span>
                      </div>
                    </figcaption>
                  </figure>
                </div>
              </div>
            </nut-swiper>
          </div>
          <div class="cxTag-div2" v-if="seriesPtTF">
            <div class="cxTag-div2-div" v-for="item in seriesPtArr" :key="item.id">
              <img :src="item.seriesImg" @click="goCxpage(item.seriesId)" alt="" class="cxTag-div2-img" />
              <div class="cxTag-div2-div1" @click="goCxpage(item.seriesId)">
                <h1 class="cxTag-div2-h1">{{ item.seriesName }}</h1>
                <h2 class="cxTag-div2-h2">{{ item.totalPrice }}</h2>
              </div>
              <div class="cxTag-div2-div2" @click="goXJpage(item)">询底价</div>
            </div>
          </div>
        </div>
      </div>
    </van-pull-refresh>
    <!-- 分享 -->
    <wxshare @changeShare="changeShare" v-if="shareTipTF"></wxshare>
    <myvideo @changeVideo="changeVideo" v-if="myVideoTF" :videoInfo="videoInfo"></myvideo>
  </div>
</template>
<script>
import axios from "axios";
import wx from "weixin-js-sdk";
import JQuery from "jquery";
import wxshare from "../components/share.vue";
import myvideo from "../components/myvideo.vue";

import { Toast } from "vant";
import { getVideoData } from "../api/cjDetail";
export default {
  inject: ["reload", "getUserToken"],
  name: "Home",
  data() {
    return {
      cjVideoTF: false,
      shareTipTF: false,
      msg: "Hello Vue",
      pulldownTxt: "加载中...",
      imgCover: "http://m.chexun.com/statics/news/img/black.85e5ee14.png",
      downLoadTF: false,
      newCurrentPage: 1,
      videoInfo: {},
      isReLoading: false,
      loopTF: true,
      imgHidTF: false,
      isLoading2: false,
      myVideoTF: false,
      isUnMore2: false,
      statusHeight: 0,
      zzSpanTF: false,
      tips: "需要下载APP才能操作哦",
      dataItem: [],
      subPLTF: false,
      tbImgTF: true,
      article: "",
      topicList: [],
      currentIndex: null,
      videoList: [],
      chexiList: [],
      zanTF: false,
      zanTF1: false,
      pullTF: false,
      titleType: 0,
      pullNum: 0,
      type: "3",
      commentList: [],
      zanListId: [],
      replylist: [],
      alllistTF: true,
      pinglunTF: false,
      pinglunNum: 0,
      wxTF: false,
      headType: 2,
      typeData: {},
      hotComment: [],
      entityId: 501058157, //501061183 112698875 112806573 112810393 501059427 501058157 112984237
      likeList: [],
      page: 1,
      num: 10,
      isHasMore: true,
      isLoading: false,
      isErr: false,
      timer: null,
      likeListData: [],
      detailPlayer: "",
      seriesIdArr: [],
      loadingTF: true,
      cxTF: true,
      timestamp: new Date().getTime(),
      contentType: "",
      imgCarouselTF: false,
      thumbsStatus: false,
      userId: "",
      pinglunValue: "",
      routerParams: {},
      userInfo: {},
      listPlayer: "",
      wifiTF: true,
      muteTF: true,
      interestTF: false,
      fromApp: 0,
      userAgent: "",
      scrollY: 0,
      showCount: true,
      domsHeight: "",
      imgSrcArr: [],
      imgTotalSrcArr: [],
      imgSrcPage: 1,
      imgSrcPageSize: 5,
      userInfoImgTF: false,
      startY: 0,
      touch: 1,
      dropDown: false,
      scrollIsToTop: 0,
      freshCount: 0,
      showAllTF: true,
      nowIndex: 1,
      wxShareUrl: "",
      seriesCjTF: false,
      seriesPtTF: false,
      seriesTF: false,
      seriesCjArr: [],
      seriesPtArr: [],
      postPinglun: false,
      pinglunData: {},
      reportId: "",
      reportIndex: 0,
      pageCjSize: 20,
      pageCjNo: 1,
      loadingToast: "",
      token: "",
      //"eyJhbGciOiJIUzI1NiJ9.eyJqdGkiOiJkOGI2OTIwMTlkNjI0MDE0ODFjYzRkODMxMDBjMDRhNSIsImlzcyI6ImNoZXh1bi1qd3QtZGVtbyIsInN1YiI6IntcIm9wZW5JZFwiOlwiXCIsXCJyZXN1bHRDb2RlXCI6MjAwLFwicmVzdWx0U3RyXCI6XCLmk43kvZzmiJDlip9cIixcInVzZXJJZFwiOjgyNzI2OSxcInVzZXJOYW1lXCI6XCJnc3lpc2dzeVwifSIsImlhdCI6MTYyMTQwNjI0MywiZXhwIjoxOTM2NzY2MjQzfQ.50USskEMm4s8PRV5Ash-8uv7lOVeZsKAr4qQOgfNuoI",
      // "eyJhbGciOiJIUzI1NiJ9.eyJqdGkiOiJiODUyNDYzMjE5OGM0NjRjODdhYzgwNTFiNTJkYjFjZSIsImlzcyI6ImNoZXh1bi1qd3QtZGVtbyIsInN1YiI6IntcIm9wZW5JZFwiOlwiXCIsXCJyZXN1bHRDb2RlXCI6MjAwLFwicmVzdWx0U3RyXCI6XCLmk43kvZzmiJDlip9cIixcInVzZXJJZFwiOjgyNTc2OSxcInVzZXJOYW1lXCI6XCJFVl9JUkVoY1J6M1VcIn0iLCJpYXQiOjE2MTU4MDMyMTcsImV4cCI6MTkzMTE2MzIxN30.owGf0hVNhbKshZ-LwNG69H8g2iJmd6iQnjmPmpGUlIU",
    };
  },
  components: {
    wxshare,
    myvideo,
  },
  mounted() {
    this.token = window.localStorage.getItem("userToken");
    this.userId = window.localStorage.getItem("userId");
    this.getRouterParams();
    this.userAgent = navigator.userAgent.toLowerCase();
  },
  methods: {
    onRefresh() {
      setTimeout(() => {
        this.page = 1;
        this.seriesIdArr = [];
        this.likeList = [];
        this.isReLoading = false;
        this.getRouterParams();
      }, 1000);
    },
    //接受video参数
    changeVideo(val) {
      this.myVideoTF = val;
      this.detailPlayer.play();
    },
    changeShare(val) {
      this.shareTipTF = val;
    },
    //评论个人
    writePL(data, index) {
      if (!this.token) {
        this.getUserToken();
      } else {
        this.pinglunData = data;
        this.postPinglun = true;
        this.pinglunTF = true;
        this.zzSpanTF = true;
        setTimeout(() => {
          let inputFocusOn = this.$refs.inputFocus;
          inputFocusOn.focus();
          this.pinglunNum += 1;
        }, 500);
      }
    },
    //获取wx浏览器网络状态
    getNetType(typeData) {
      if (typeData.entityType == 2 || typeData.entityType == 7) {
        let that = this;
        wx.getNetworkType({
          success: function (res) {
            var networkType = res.networkType; // 返回网络类型2g，3g，4g，wifi
            if (networkType !== "wifi") {
              console.log(networkType);
              that.wifiTF = false;
              that.detailPlayer.pause();
            } else {
              console.log(networkType);
            }
          },
        });
      }
    },
    // 微信分享
    wxShareData(typeData) {
      if (this.userAgent.match(/MicroMessenger/i) == "micromessenger") {
        var that = this;
        JQuery.ajax({
          type: "get",
          url: "http://reg.chexun.com/api/WeiXinInfo.ashx",
          cache: false,
          dataType: "jsonp",
          data: { url: that.wxShareUrl },
          jsonpCallback: "funcweixin",
          success: function (data) {
            wx.config({
              debug: false, // true开启调试模式,pc端会console.log手机端会alert
              appId: data.appId, // 必填，公众号的唯一标识，填自己的！
              timestamp: data.wxinfo.timestamp, // 必填，生成签名的时间戳，刚才接口拿到的数据
              nonceStr: data.wxinfo.nonceStr, // 必填，生成签名的随机串
              signature: data.wxinfo.signature, // 必填，签名，见附录1
              jsApiList: [
                "updateTimelineShareData",
                "updateAppMessageShareData",
              ],
            });
            wx.ready(function () {
              //分享到朋友圈
              wx.updateTimelineShareData({
                title: typeData.title, // 分享时的标题
                link: that.wxShareUrl, // 分享时的链接
                imgUrl: typeData.cover, // 分享时的图标
                success: function () {
                  // alert("分享成功");
                },
                cancel: function () {
                  // alert("取消分享");
                },
              });
              //分享给朋友
              wx.updateAppMessageShareData({
                title: typeData.title,
                desc: typeData.description,
                link: that.wxShareUrl,
                imgUrl: typeData.cover,
                success: function () {
                  // alert("分享成功");
                },
                cancel: function () {
                  // alert("取消分享");
                },
              });
            });
          },
          error: function () {
            alert("error");
          },
        });
      }
    },
    //打开车系弹窗
    openCxTag() {
      this.seriesTF = true;
      for (let i in this.seriesIdArr) {
        if (this.seriesIdArr[i].disstate > 0) {
          this.seriesCjArr.push(this.seriesIdArr[i]);
          this.seriesCjTF = true;
        } else {
          this.seriesPtArr.push(this.seriesIdArr[i]);
          this.seriesPtTF = true;
        }
      }
    },
    //关闭车系弹窗
    closeCxTag() {
      this.seriesTF = false;
      this.seriesCjArr = [];
      this.seriesPtArr = [];
    },
    //跳转账号页
    goHomePage(index) {
      //this.$router.push("/");
    },
    //关闭4g/wifi 提示
    closewifiTips(index) {
      if (index == 0) {
        this.wifiTF = true;
      } else {
        this.wifiTF = true;
        this.detailPlayer.play();
      }
    },
    //关闭评论遮罩层
    closezzSpan() {
      this.pinglunTF = false;
      this.zzSpanTF = false;
      this.postPinglun = false;
      this.subPLTF = false;
    },
    //关闭图文图片弹层
    closeCarouselDiv() {
      this.newCurrentPage = 1;
      this.imgCarouselTF = false;
      this.imgSrcPage = 1;
      this.imgSrcArr = [];
      this.imgTotalSrcArr = [];
    },
    //图文图片弹层无限加载
    imgCarouselScroll(e) {
      const ele = e.srcElement ? e.srcElement : e.target;
      if (this.imgSrcArr.length < this.imgTotalSrcArr.length) {
        let distance = this.imgSrcArr.length * 210 - 375;
        distance = ele.scrollLeft - distance;
        if (distance > -50) {
          this.imgSrcPage = this.imgSrcPage + 1;
          this.pagination(this.imgSrcPage, this.imgSrcPageSize);
        }
      }
    },
    //图文图片弹层分页
    pagination(pageNo, pageSize, array) {
      var offset;
      if (pageNo == 1) {
        offset = 0;
      } else {
        offset = (pageNo - 1) * pageSize;
        offset = offset + 1;
      }
      // this.imgSrcArr = (offset + pageSize >= this.imgTotalSrcArr.length) ? this.imgTotalSrcArr.slice(offset, this.imgTotalSrcArr.length) : this.imgTotalSrcArr.slice(offset, offset + pageSize);
      this.imgSrcArr = this.imgSrcArr.concat(
        offset + pageSize >= this.imgTotalSrcArr.length
          ? this.imgTotalSrcArr.slice(offset, this.imgTotalSrcArr.length)
          : this.imgTotalSrcArr.slice(offset, offset + pageSize)
      );
    },
    //打开图文图片弹层
    openCarousel(data, e) {
      let imgUrl = e.target.currentSrc;
      if (e.target.nodeName == "IMG") {
        this.imgCarouselTF = true;
        let imgReg = /<img.*?(?:>|\/>)/gi; //匹配图片中的img标签
        let srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i; // 匹配图片中的src
        let arr = data.match(imgReg); //筛选出所有的img
        // 存放所有图片的src
        let src;
        for (let i = 0; i < arr.length; i++) {
          src = arr[i].match(srcReg);
          // 获取图片地址
          this.imgTotalSrcArr.push(src[1]);
        }
        imgUrl = imgUrl.replace(/amp;/g, "");
        for (let x in this.imgTotalSrcArr) {
          this.imgTotalSrcArr[x] = this.imgTotalSrcArr[x].replace(/amp;/g, "");
          if (this.imgTotalSrcArr[x] == imgUrl) {
            this.newCurrentPage = this.newCurrentPage + parseInt(x);
          }

          this.imgSrcArr.push(this.imgTotalSrcArr[x]);
        }
        if (this.imgSrcArr.length < 2) {
          this.loopTF = false;
        }
        // this.imgSrcArr.length = this.imgSrcArr.length + 1;

        // this.imgSrcArr = this.imgSrcArr.concat(this.imgTotalSrcArr);

        // this.pagination(this.imgSrcPage, this.imgSrcPageSize);
      }
    },

    //改变视频简介的箭头方向
    changeTBimg() {
      this.tbImgTF = !this.tbImgTF;
    },
    //打开下载页
    openDownload() {
      this.$toast.text(this.tips);
      this.downLoadTF = true;
    },
    //关闭下载页
    closeDown() {
      this.downLoadTF = false;
    },
    //下载app
    goDownLoadApp() {
      if (this.userAgent.match(/Android/i) == "android") {
        window.location.href =
          "https://a.app.qq.com/o/simple.jsp?pkgname=com.chexun.platform";
      } else {
        //ios
        window.location.href =
          "itms-apps://apps.apple.com/cn/app/%E8%BD%A6%E8%AE%AF%E7%BD%91/id577675997";
      }
    },
    //猜你喜欢列表跳转到详情页
    goDetail(item) {
      if (item.entityType == 1) {
        this.detailPlayer.pause();
        this.myVideoTF = true;
        this.videoInfo = item;
      } else {
        this.seriesIdArr = [];
        let detailTime;
        if (item.creationTime) {
          detailTime = item.creationTime.substring(0, 10);
        } else {
          detailTime = item.createTime.substring(0, 10);
        }
        this.$router.push({
          path: `/${detailTime}/${item.entityId}.html`,
        });
      }
    },
    //拆解详情页
    goCjDepage(item) {
      this.$router.push({
        path: "/cjDetail",
        query: {
          reportId: item.reportId,
        },
      });
    },
    //分享
    shareUrl(params, item) {
      if (this.userAgent.match(/MicroMessenger/i) == "micromessenger") {
        this.shareTipTF = true;
        if (!params) {
          let detailTime;
          if (item.creationTime) {
            detailTime = item.creationTime.substring(0, 10);
          } else {
            detailTime = item.createTime.substring(0, 10);
          }
          this.wxShareUrl =
            window.location.origin + `/${detailTime}/${item.entityId}.html`;
          this.wxShareData(item);
        } else {
          this.wxShareUrl = window.location.href;
          this.wxShareData(this.typeData);
        }
      } else {
        this.downLoadTF = true;
      }
    },
    //返回
    goBack() {
      this.$router.go(-1);
    },
    //跳转标签页
    goTagPage(item) {
      this.openDownload();
    },
    //前往车系页
    goCxpage(seriesId) {
      window.location.href =
        "http://m.chexun.com/app/appseries#/?seriesId=" + seriesId;
    },
    //打开询价
    goXJpage(item) {
      this.openDownload();
    },
    //关注
    interest(count) {
      if (!this.token) {
        this.getUserToken();
      } else {
        let that = this;
        axios
          .get("https://api.chexun.com/user/updateUserFans", {
            params: {
              opType: count,
              token: this.token,
            },
          })
          .then(function (response) {
            if (response.data.status == "error") {
              that.$toast.text(response.data.msg);
            } else {
              that.interestTF = !that.interestTF;
              if (that.interestTF) {
                that.$toast.text("关注成功");
              } else {
                that.$toast.text("取消成功");
              }
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    //获取拆解视频数据
    getDisVideoData() {
      let params = {
        reportId: this.reportId,
        reportVersion: 1,
        sort: 1,
        pageSize: this.pageCjSize,
        pageNo: this.pageCjNo,
        classType: 13,
        token: this.token,
      };
      getVideoData(params).then((res) => {
        //返回值
        this.typeData.playUrl = res.data.list[this.reportIndex].playUrl;
        this.typeData.title = res.data.list[this.reportIndex].title;
        this.typeData.description = res.data.list[this.reportIndex].description;
        this.tbImgTF = !this.tbImgTF;
        this.$forceUpdate();
        this.$nextTick(() => {
          this.$refs.videoHeaderFixed.style.height =
            this.$refs.videoHeaderData.offsetHeight + "px";
          this.videoControl2(
            res.data.list[this.reportIndex].videoCover,
            res.data.list[this.reportIndex].playUrl
          );
        });
        // this.videoList = res.data.list;
        // for(let i in this.videoList){
        //   this.videoList[i].uploadCover = this.videoList[i].videoCover;
        //   this.videoList[i].playing = false;
        // }
      });
    },
    //获取路由参数
    getRouterParams() {
      if (this.$route.query.entityId) {
        this.entityId = this.$route.query.entityId;
        this.getType(this.entityId);
      } else {
        let pathStr = this.$route.path;
        let pathIndex = pathStr.lastIndexOf("/");
        let pathIndex1 = pathStr.lastIndexOf(".");
        pathStr = pathStr.substring(pathIndex + 1, pathIndex1);
        if (pathStr) {
          this.entityId = pathStr;
          this.getType(this.entityId);
        } else {
          let params = {
            mcnId: 111,
          };
          this.entityId = 501074165; //接口暂不支持无entityId请求，默认随便一片文章
          this.cjVideoTF = true;
          this.loadingTF = false;
          this.headType = 1;
          this.reportId = this.$route.query.reportId;
          this.reportIndex = this.$route.query.index;
          this.getLikeDate();
          this.getUserInfo(params);
          // this.getDisVideoData();
        }
      }

      this.wxShareUrl = window.location.href;
    },
    //获取用户信息
    getUserInfo(typeData) {
      let that = this;
      axios
        .get("https://api.chexun.com/user/miniAppMCNInforApi", {
          params: {
            mcnId: typeData.mcnId,
            token: this.token,
          },
        })
        .then(function (response) {
          that.userInfo = response.data.data;
          if (
            that.userInfo.mcnCover == "" ||
            that.userInfo.mcnCover == undefined
          ) {
            that.userInfoImgTF = true;
          } else {
            that.userInfoImgTF = false;
          }
          if (escape(that.userInfo.viewCount).indexOf("%u") < 0) {
            if (that.userInfo.viewCount === "0") {
              that.showCount = false;
            }
          }
          if (that.userInfo.fansFollowStatus == 0) {
            that.interestTF = true;
          } else {
            that.interestTF = false;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    //跳到评论处
    goComment() {
      if (this.commentList.length == 0) {
        if (!this.token) {
          this.getUserToken();
        } else {
          this.pinglunTF = true;
          this.zzSpanTF = true;
          setTimeout(() => {
            let inputFocusOn = this.$refs.inputFocus;
            this.$nextTick(() => {
              inputFocusOn.focus();
              this.pinglunNum += 1;
            });
          }, 300);
        }
      } else {
        this.$refs.allCommentList.scrollIntoView({
          behavior: "smooth",
          block: "center", //定义垂直方向的对齐， "start", "center", "end", 或 "nearest"之一。默认为 "start"。
          inline: "nearest", //"start", "center", "end", 或 "nearest"之一。默认为 "nearest"。
        });
      }
    },
    //点赞喜欢文章
    likeArticle(index) {
      if (!this.token) {
        this.getUserToken();
      } else {
        let that = this;
        const likeData = new URLSearchParams();
        likeData.append("contentId", this.entityId);
        likeData.append("contentType", this.contentType);
        likeData.append("token", this.token);
        axios({
          url: "https://api.chexun.com/thumbsUpOrDown",
          method: "post",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          data: likeData,
        })
          .then(function (response) {
            if (index == 0) {
              if (escape(that.typeData.thumbsCounts).indexOf("%u") < 0) {
                that.typeData.thumbsCounts =
                  parseInt(that.typeData.thumbsCounts) + 1;
              } else if (that.typeData.thumbsCounts == "赞") {
                that.typeData.thumbsCounts = 1;
              }
            } else if (index == 1) {
              if (escape(that.typeData.thumbsCounts).indexOf("%u") < 0) {
                that.typeData.thumbsCounts =
                  parseInt(that.typeData.thumbsCounts) - 1;
              }
            }

            that.thumbsStatus = response.data.thumbsStatus;
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    //切换视频
    playVideo(item, index) {
      console.log(item);
      this.seriesIdArr = [];
      this.likeList = [];
      this.entityId = item.entityId;
      this.getType(this.entityId, 1, index);
      this.detailPlayer.src({
        src: item.playUrl,
      });
      this.detailPlayer.poster(item.cover);
    },
    //获取播放列表视频
    getVideoList(Cindex) {
      for (let x in this.videoList) {
        this.videoList[x].playing = false;
        // this.videoList[x].muted = true;
      }
      if (Cindex) {
        if (
          this.typeData.seriesId != undefined &&
          this.typeData.seriesId.length != 0
        ) {
          for (let i of this.videoList[Cindex].seriesId) {
            this.getCXdata(i);
          }
        } else {
          this.cxTF = false;
        }

        this.videoList[Cindex].playing = true;

        // this.videoList[Cindex].muted = false;
      } else {
        let that = this;
        axios
          .get("https://api.chexun.com/editorList", {
            params: {
              entityId: this.entityId,
              entityType: this.typeData.entityType,
              pageNo: "",
              pageSize: "",
              token: this.token,
            },
          }) //S960_540
          .then(function (response) {
            that.videoList = response.data.data.itemsList;
            for (let x in that.videoList) {
              that.videoList[x].uploadCover = that.videoList[x].cover.replace(
                "default",
                "S960_540"
              );
              if (
                that.videoList[x].title === undefined ||
                that.videoList[x].title === ""
              ) {
                that.videoList[x].title = that.videoList[x].description;
              }
            }
            that.videoList[0].playing = true;
            if (
              that.typeData.seriesId != undefined &&
              that.typeData.seriesId.length != 0
            ) {
              for (let i of that.videoList[0].seriesId) {
                that.getCXdata(i);
              }
            } else {
              that.cxTF = false;
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    //获取相关车系
    getCXdata(seriesId) {
      // this.seriesIdArr = [];
      let that = this;
      axios
        .get("http://api.chexun.com/pc/items/seriesInfo", {
          params: {
            seriesId: seriesId,
          },
        })
        .then(function (response) {
          let res = response.data.data;
          if (response.data.code == 100999) {
            that.cxTF = false;
          } else {
            if (res.seriesImg == "" || res.seriesImg == undefined) {
              that.cxTF = false;
            } else {
              that.cxTF = true;
              if (res.minPrice === res.maxPreice && res.minPrice !== 0) {
                res.totalPrice = "￥" + res.minPrice;
              } else {
                if (res.minPrice === 0 && res.maxPreice === 0) {
                  res.totalPrice = "暂无";
                } else if (res.minPrice !== 0 && res.maxPreice === 0) {
                  res.totalPrice = "￥" + res.minPrice + "万";
                } else if (res.minPrice === 0 && res.maxPreice !== 0) {
                  res.totalPrice = "￥" + res.maxPreice + "万";
                } else {
                  res.totalPrice =
                    "￥" + res.minPrice + "万-" + res.maxPreice + "万";
                }
              }
              that.seriesIdArr.push(res);
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    //视频页面头部视频
    videoControl2(cover, playUrl) {
      this.showAllTF = false;
      this.imgCover = cover;
      let that = this;
      this.detailPlayer = this.$video(
        "myvideo" + this.timestamp,
        {
          controls: true,
          autoplay: true,
          poster: this.imgCover,
          sources: [
            {
              src: playUrl,
            },
          ],
        },
        function onPlayerReady() { }
      );
    },
    //获取所有评论
    getCommentData(type) {
      let that = this;
      axios
        .get("https://api.chexun.com/miniAppAllCommentList", {
          params: {
            id: this.entityId,
            commentType: type,
            hotType: 1,
            token: this.token,
          },
        })
        .then(function (response) {
          if (response.data.data.allComment) {
            that.commentList = response.data.data.allComment;
            for (let i in that.commentList) {
              that.commentList[i].myuserId = that.userId;
            }
            that.hotComment = response.data.data.hotComment;
            if (that.commentList.length > 6 && that.pullNum == 0) {
              that.alllistTF = true;
            } else {
              that.alllistTF = false;
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    //猜你喜欢
    getLikeDate() {
      let that = this;
      const likeData = new URLSearchParams();
      likeData.append("entityId", this.entityId);
      likeData.append("pageNo", this.page);
      likeData.append("pageSize", this.num);
      likeData.append("token", this.token);
      axios({
        url: "https://api.chexun.com/pc/items/recommendItems",
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        data: likeData,
      })
        .then(function (response) {
          that.likeListData = response.data.data;
          let idArray = [];
          for (let y in that.likeListData) {
            that.likeList.push(that.likeListData[y]);
            if (that.likeListData[y].entityType == 2) {
              idArray.push(that.likeListData[y].entityId);
            }
          }
          for (let i in that.likeListData) {
            if (
              that.likeListData[i].newsPics != "" &&
              that.likeListData[i].newsPics != undefined
            ) {
              if (that.likeListData[i].newsPics.length >= 2) {
                that.likeListData[i].titleType = 3;
              } else {
                that.likeListData[i].titleType = 1;
              }
            } else {
              that.likeListData[i].titleType = 0;
            }
          }
          setTimeout(() => {
            // that.videoControl1(that.likeListData);
            that.isLoading = false;
          }, 100);
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    // 获取页面头部数据 文章或者视频
    getType(entityId, number, Cindex) {
      let entityIds = "";
      if (entityId) {
        entityIds = entityId;
      } else {
        entityIds = this.entityId;
      }
      let that = this;
      axios
        .get("https://api.chexun.com/pc/items/info", {
          params: {
            entityId: entityIds,
            userId: this.userId,
          },
        })
        .then(function (response) {
          that.typeData = response.data.data;
          // 检查是否已存在该脚本
          var scriptId = 'external-script';
          if (document.getElementById(scriptId)) {
            console.log('存在script标签')
            document.getElementById(scriptId).remove()
          }
          if (that.typeData.newsContent.includes('video-container')) {
            // 存在
            var regex = /<script\b[^>]*>([\s\S]*?)<\/script>/gi;
            var scripts = regex.exec(that.typeData.newsContent)[0];
            var match = scripts.match(/src="([^"]*)"/);

            if (match) {
              var srcValue = match[1];


              // 创建脚本标签
              const script = document.createElement('script');
              script.id = scriptId;
              script.src = srcValue;
              document.body.appendChild(script);
            }

          }
          var ua = navigator.userAgent.toLowerCase();
          if (ua.match(/MicroMessenger/i) == "micromessenger") {
            that.$nextTick(() => {
              that.wxShareData(that.typeData);
            });
          }

          if (that.freshCount === 1) {
            that.pulldownTxt = "刷新成功";
          }
          if (escape(that.typeData.thumbsCounts).indexOf("%u") < 0) {
            if (that.typeData.thumbsCounts === "0") {
              that.typeData.thumbsCounts = "赞";
            }
          }
          if (
            that.typeData.title == null ||
            that.typeData.title == "" ||
            that.typeData.title == undefined
          ) {
            that.typeData.title = that.typeData.description;
          }
          document.title = that.typeData.title + "-车讯网";
          that.typeData.month = that.typeData.creationTime.slice(5, 7);
          that.typeData.day = that.typeData.creationTime.slice(8, 10);
          that.typeData.hour = that.typeData.creationTime.slice(11, 13);
          that.typeData.minutes = that.typeData.creationTime.slice(14, 16);
          that.getUserInfo(that.typeData);
          that.loadingTF = false;
          that.thumbsStatus = that.typeData.isThumbs;
          if (that.typeData.entityType == 2 || that.typeData.entityType == 7) {
            that.headType = 1;
            that.$nextTick(() => {
              if (that.freshCount !== 1 && number !== 1) {
                that.$refs.videoHeaderFixed.style.height =
                  parseInt(that.$refs.videoHeaderData.offsetHeight) +
                  parseInt(that.statusHeight) +
                  "px";
              }
              that.$refs.statusHeight.style.height = that.statusHeight + "px";
              that.$refs.videoHeaderData.style.top = 0;
              that.dropDown = false;
            });
            that.contentType = that.typeData.entityType;

            that.getLikeDate();
            // if (ua.match(/MicroMessenger/i) == "micromessenger") {
            //   that.$nextTick(() => {
            //     that.getNetType(that.typeData);
            //   });
            // }
            if (number != 1 && that.freshCount === 0) {
              that.$nextTick(() => {
                that.videoControl2(that.typeData.cover, that.typeData.playUrl);
              });
            }
            if (number == 1) {
              that.getVideoList(Cindex);
            } else {
              that.getVideoList();
            }

            that.getCommentData(that.typeData.entityType);
          } else if (that.typeData.entityType == 5) {
            that.getLikeDate();
            that.$nextTick(() => {
              that.$refs.videoHeader2.style.paddingTop =
                that.statusHeight + "px";
              that.$refs.videoHeader1.style.paddingTop =
                that.statusHeight + "px";
              if (that.freshCount === 1) {
                that.$refs.videoHeader1.style.top = 0;
              }
              that.dropDown = false;
              that.showAllTF = false;
            });

            that.contentType = that.typeData.entityType;
            that.headType = 2;
            that.getCommentData(that.typeData.entityType);
            if (
              that.typeData.seriesId == undefined ||
              that.typeData.seriesId.length == 0
            ) {
              that.cxTF = false;
            } else {
              for (let i in that.typeData.seriesId) {
                that.getCXdata(that.typeData.seriesId[i]);
              }
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    //评论点赞数
    dianzan(index, id, item) {
      if (!this.token) {
        this.getUserToken();
      } else {
        let list = this.zanListId;
        if (!this.commentList[index].isLike) {
          this.zanListId.push(id);
          this.commentList[index].thumbUpCount += 1;
          this.commentList[index].isLike = !this.commentList[index].isLike;
        } else {
          // 取消点赞
          this.commentList[index].isLike = !this.commentList[index].isLike;
          this.commentList[index].thumbUpCount -= 1;
          for (let i in this.zanListId) {
            if (this.zanListId[i] == id) {
              this.zanListId.splice(i, 1);
            }
          }
        }
      }

      let that = this;
      const likeData = new URLSearchParams();
      likeData.append("contentId", id);
      likeData.append("contentType", 3);
      likeData.append("token", this.token);
      axios({
        url: "https://api.chexun.com/thumbsUpOrDown",
        method: "post",
        data: likeData,
      })
        .then(function (response) { })
        .catch(function (error) {
          console.log(error);
        });
    },
    clickAlllist() {
      this.alllistTF = !this.alllistTF;
      this.pullNum = 1;
    },
    clickZan1() {
      this.zanTF1 = !this.zanTF1;
    },
    clickPinglung() {
      if (!this.token) {
        this.getUserToken();
      } else {
        this.zzSpanTF = true;
        this.pinglunTF = true;
        setTimeout(() => {
          let inputFocusOn = this.$refs.inputFocus;
          this.$nextTick(() => {
            inputFocusOn.focus();
            this.pinglunNum += 1;
          });
        }, 500);
      }
    },
    onRodeChange() {
      setTimeout(() => {
        if (this.pinglunNum == 1) {
          this.pinglunTF = false;
          this.pinglunNum = 0;
        }
      }, 120);
    },
    reset() {
      document.body.style.height = window.innerHeight + "px";
      this.$refs.inputFocus.style.bottom = 0;
    },
    delComment(item) {
      if (!this.token) {
        this.getUserToken();
      } else {
        let that = this;
        const likeData = new URLSearchParams();
        likeData.append("cId", item.id);
        likeData.append("token", this.token);
        axios({
          url: "https://api.chexun.com/miniAppDelComment",
          method: "post",
          data: likeData,
        })
          .then(function (response) {
            that.$toast.text(response.data.msg);
            that.getCommentData(that.typeData.entityType);
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    //提交评论
    submitPinglun() {
      this.subPLTF = true;
      if (this.pinglunValue != "") {
        this.loadingToast = this.$toast.loading("正在提交..", {
          cover: false,
        });

        if (!this.postPinglun) {
          let that = this;
          this.pinglunNum = 0;
          const likeData = new URLSearchParams();
          likeData.append("entityId", this.entityId);
          likeData.append("content", this.pinglunValue);
          likeData.append("origin", 305);
          likeData.append("token", this.token);
          likeData.append("commentType", this.typeData.entityType);
          axios({
            url: "https://api.chexun.com/appCommentSubmit",
            method: "post",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
            data: likeData,
          })
            .then(function (response) {
              if (response.data.status == "success") {
                that.loadingToast.hide();
                that.$toast.text("评论成功");
                that.getCommentData(that.typeData.entityType);
                //调用方法 提交完成后
                that.subPLTF = false;
                that.pinglunTF = false;
                that.zzSpanTF = false;
                that.$nextTick(() => {
                  setTimeout(() => {
                    that.$refs.allCommentList.scrollIntoView({
                      behavior: "smooth",
                      block: "center", //定义垂直方向的对齐， "start", "center", "end", 或 "nearest"之一。默认为 "start"。
                      inline: "nearest", //"start", "center", "end", 或 "nearest"之一。默认为 "nearest"。
                    });
                  }, 500);
                });

                that.pinglunValue = "";
              } else {
                that.$toast.text(response.data.msg);
              }
            })
            .catch(function (error) {
              that.$toast.text(error);
            });
        } else {
          let that = this;
          const likeData1 = new URLSearchParams();
          likeData1.append("entityId", this.pinglunData.entityId);
          likeData1.append("content", this.pinglunValue);
          likeData1.append("origin", 305);
          likeData1.append("token", this.token);
          likeData1.append("commentType", this.pinglunData.commentType);
          likeData1.append("replyCommentId", this.pinglunData.id);
          likeData1.append("replyUserId", this.pinglunData.fromUserId);
          axios({
            url: "https://api.chexun.com/appCommentSubmit",
            method: "post",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
            data: likeData1,
          })
            .then(function (response) {
              if (response.data.status == "success") {
                that.loadingToast.hide();
                that.$toast.text("评论成功");
                that.getCommentData(that.typeData.entityType);
                //调用方法 提交完成后
                that.subPLTF = false;
                that.pinglunTF = false;
                that.zzSpanTF = false;
                that.postPinglun = false;
                that.pinglunValue = "";
              } else {
                that.$toast.text(response.data.msg);
              }
            })
            .catch(function (error) {
              that.$toast.text(error);
            });
        }
      } else {
        // that.$toast.text('评论不能为空');
        this.$dialog({
          title: "评论不能为空",
          noOkBtn: true,
          cancelBtnTxt: "我知道了",
        });
      }
    },
    pullReply(index, id) {
      let replyArray = this.replylist;
      if (replyArray.indexOf(id) == -1) {
        this.replylist.push(id);
        this.commentList[index].pullTF = !this.commentList[index].pullTF;
      } else {
        this.commentList[index].pullTF = !this.commentList[index].pullTF;
        for (let i in this.replylist) {
          if (this.replylist[i] == id) {
            this.replylist.splice(i, 1);
          }
        }
      }
    },
    onInfinite() {
      this.isLoading = true;
      this.timer = setTimeout(() => {
        if (this.page >= 1 && this.likeListData.length == 10) {
          if (this.page == 1) {
            this.page = 2;
            this.getLikeDate();
            this.page = this.page + 1;
          } else {
            this.getLikeDate();
            this.page = this.page + 1;
          }
        } else if (this.page == 1 && this.likeListData.length == 0) {
          this.page = 2;
          this.getLikeDate();
          this.page = this.page + 1;
        } else {
          this.isHasMore = false;
        }
      }, 300);
    },
  },
  watch: {
    $route(to, from) {
      // 对路由变化作出响应...
      this.reload();
    },
  },
  destroyed() {
    clearTimeout(this.timer);
  },
};
</script>
<style>
.imgOpacity {
  opacity: 0;
}

.displayNone {
  opacity: 0;
}

#app {
  width: 100%;
  height: 100%;
}

.app-span {
  width: 100%;
  height: 100%;
  background-color: #fff;
  z-index: 99999;
  position: fixed;
  top: 0;
  left: 0;
}

.video-js .vjs-tech {
  position: relative !important;
}

.video-js .vjs-time-control {
  display: block !important;
  padding: 0 !important;
  min-width: unset !important;
  line-height: 30px !important;
  padding-left: 2px !important;
  padding-right: 2px !important;
  font-size: 12px !important;
}

.video-js .vjs-remaining-time {
  display: none !important;
}

.video-js {
  width: 100%;
  height: 188px;
}

.video-js .vjs-control-bar {
  height: 30px !important;
}

.videoDetail-videoHeader {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 7;
  width: 100%;
  height: auto;
  background-image: url(http://file.chexun.com/chexun/statics/m/news/images/img/shade.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.videoDetail-videoHeader1 {
  position: fixed;
  top: 0;
  left: 0;
  height: 56px;
  background-color: #fff;
  width: 100%;
  display: flex;
  align-items: center;
  z-index: 7;
}

.videoDetail-videoHeader2 {
  width: 100%;
  height: 56px;
}

.videoDetail-videoHeader3 {
  width: 100%;
  height: auto;
}

.videoDetail-bottomImg {
  width: 100%;
}

.videoDetail-bottomImg img {
  width: 100%;
}

.videoDetail-shade {
  position: absolute;
  top: 0;
  left: 0;
}

.videoDetail-videoContent {
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
  z-index: 999;
}

.videoDetail-videoHeaderFixed {
  width: 100%;
}

.videoContent-div {
  width: 9px;
  height: 15px;
  flex-shrink: 0;
  margin-left: 12px;
}

.videoContent-div .videoContent-img {
  width: 100%;
}

.videoContent-head {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
}

.videoContent-div1 {
  display: flex;
  align-items: center;
  flex: 1;
  margin-left: 21px;
}

.videoContent-span {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: block;
  margin-right: 8px;
  flex-shrink: 0;
}

.videoContent-span img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.videoContent-div1-div p {
  font-size: 14px;
  color: #fff;
  line-height: 16px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.videoContent-div1-div-span {
  display: flex;
}

.videoContent-div1-div span {
  font-size: 12px;
  color: #999999;
  display: block;
  margin-right: 5px;
}

.videoContent-div2 {
  padding-left: 20.8px;
  padding-right: 20.8px;
  height: 25px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #fff;
  flex-shrink: 0;
  margin-right: 20px;
}

.videoContent-div2-other {
  padding-left: 12.8px;
  padding-right: 12.8px;
}

.videoDetail-headerContentFixed {
  position: fixed;
}

.videoDetail-div3 {
  width: 100%;
}

.videoDetail-div3 .videoDetail-video {
  width: 355px;
  height: 202px;
  margin: 0 auto;
  box-shadow: 0px 8px 5px -5px rgba(236, 236, 236, 0.7);
}

.videoDetail-videoInfo {
  padding: 18px 15px;
  padding-top: 10px;
  padding-bottom: 0;
}

.videoDetail-videoInfo1 {
  padding-top: 0;
  padding-bottom: 0;
}

.videoInfo-div {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.videoInfo-div .videoInfo-h1 {
  font-size: 16px;
  color: #121826;
  word-break: break-all;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-height: 22px;
}

.videoInfo-div .videoInfo-h12 {
  font-size: 18px;
  line-height: 30px;
  color: #121826;
}

.videoInfo-div .videoInfo-img {
  width: 10px;
  height: 6px;
  flex-shrink: 0;
}

.videoInfo-div1 {
  display: flex;
  align-items: center;
  padding-top: 7px;
  flex-wrap: wrap;
}

.videoInfo-topic {
  padding: 4px 7px;
  background-color: #f5f5f8;
  border-radius: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  margin-bottom: 10px;
}

.videoInfo-topic .topic-img {
  width: 12px;
  height: 12px;
  flex-shrink: 0;
}

.videoInfo-topic .topic-span {
  font-size: 12px;
  color: #8692ac;
  margin-left: 3px;
}

.videoInfo-div2 {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
  border-bottom: 1px solid #efefef;
  padding-bottom: 16px;
}

.videoInfo-div2New {
  border-bottom: 0;
  padding-bottom: 0;
}

.videoInfo-div2-div {
  display: flex;
  align-items: center;
}

.videoInfo-div2-div img {
  flex-shrink: 0;
}

.videoInfo-div2-div .videoInfo-div2-img {
  width: 19px;
  height: 16px;
}

.videoInfo-div2-div .videoInfo-div2-img1 {
  width: 15px;
  height: 15px;
}

.videoInfo-div2-div .videoInfo-div2-img3 {
  width: 16px;
  height: 16px;
}

.videoInfo-div2-div span {
  font-size: 12px;
  color: #6c7ea2;
  margin-left: 3px;
}

.videoDetail-data {
  padding: 0 15px;
  padding-right: 0;
  margin-top: 15px;
}

.videoList-div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  padding-right: 15px;
}

.videoList-div h1 {
  color: #344058;
  font-size: 14px;
}

.videoList-div img {
  width: 18px;
}

.videoList-div1 {
  display: flex;
  overflow-x: scroll;
  margin-bottom: 15px;
}

.videoList-figure {
  width: 128px;
  flex-shrink: 0;
  margin-right: 5px;
}

.videoList-figure:nth-last-child(1) {
  padding-right: 5px;
}

.videoList-figure .videoList-figure-img {
  width: 100%;
  height: 72px;
  border-radius: 5px;
}

.videoList-figure-div {
  position: relative;
}

.videoList-figure-div1 {
  position: absolute;
  width: 100%;
  bottom: 4px;
  left: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.videoList-figure-playing {
  padding: 2px 5px;
  background-color: #fff;
  border-radius: 9px;
  display: flex;
  align-items: center;
  margin-left: 3px;
}

.videoList-figure-img1 {
  width: 9px;
  height: 8px;
  flex-shrink: 0;
  margin-right: 2px;
}

.videoList-figure-playing span {
  font-size: 10px;
  color: #344058;
}

.videoList-figure-time {
  padding: 3px 5px;
  background-color: rgba(000, 000, 000, 0.496);
  border-radius: 9px;
  font-size: 10px;
  color: #fff;
  margin-right: 5px;
}

.videoList-figure figcaption .videoList-figure-h1 {
  color: #7889ac;
  font-size: 12px;
  font-weight: 500;
  margin-top: 6px;
}

.videoList-figure figcaption .changecolor {
  color: #344058;
}

.videoSwiper {
  width: 345px;
  height: 108px;
  border-radius: 5px;
  position: relative;
}

.videoSwipe-div {
  width: 100%;
  background: linear-gradient(213deg, rgba(54, 67, 87, 0.94) 0%, #313948 100%);
  border-radius: 5px;
}

.videoSwipe-posImg {
  position: absolute;
  right: 0%;
  top: 0%;
  width: 52px;
  height: 20px;
}

.videoSwipe-div figure {
  padding: 5px;
  display: flex;
  border-radius: 5px;
  height: 98px;
}

.videoSwipe-div .videoSwipe-img {
  width: 165px;
  height: 98px;
  border-radius: 5px;
  margin-right: 18px;
}

.videoSwipe-div .videoSwipe-h2 {
  font-size: 15px;
  color: #f5f5f8;
  font-weight: 500;
}

.videoSwipe-div figcaption {
  padding-top: 14px;
}

.videoSwipe-div1 {
  margin-top: 10px;
  display: flex;
  align-items: center;
}

.videoSwipe-div1 .videoSwipe-span {
  display: block;
  font-size: 13px;
  color: #fff;
  padding: 4px 8px;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 5px;
  margin-right: 5px;
}

.videoSwiper .nut-swiper.horizontal .nut-swiper-pagination {
  bottom: 0;
}

.videoSwiper .nut-swiper {
  height: 124px;
  overflow: unset;
  overflow-x: hidden;
}

.videoSwiper .nut-swiper .nut-swiper-pagination .swiper-pagination-bullet {
  width: 8px;
  height: 2px;
  background-color: #dfdfdf;
  border-radius: 1px;
}

.videoSwiper .nut-swiper .nut-swiper-pagination .swiper-pagination-bullet.active {
  width: 12px;
  background-color: #333333;
  border-radius: 1px;
}

.videoDetail-comment {
  padding: 0 15px;
}

.comment-h1 {
  font-size: 15px;
  color: #121826;
  margin-top: 15px;
  margin-bottom: 20px;
}

.comment-div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 16px;
}

.comment-div-left figure {
  display: flex;
  align-items: center;
}

.comment-div-img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  margin-right: 6px;
  flex-shrink: 0;
}

.comment-div-img img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.comment-reply .comment-div-left figure figcaption {
  display: flex;
  align-items: center;
}

.comment-div-left figure figcaption span {
  display: block;
}

.comment-div-left figure figcaption .comment-span-name {
  font-size: 14px;
  color: #6c7ea2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.comment-span-time {
  font-size: 10px;
  color: #999999;
}

.comment-div-right {
  display: flex;
}

.comment-right-div {
  display: flex;
  align-items: center;
  margin-left: 20px;
}

.comment-right-img {
  width: 12px;
  height: 11px;
  margin-right: 3px;
}

.comment-right-img1 {
  width: 12px;
  height: 12px;
  margin-right: 4px;
}

.comment-right-img2 {
  width: 12px;
  height: 12px;
  margin-right: 4px;
  background-image: url(http://file.chexun.com/chexun/statics/m/news/images/img/zan.png);
  background-size: 100% auto;
  background-repeat: no-repeat;
}

.comment-right-imgdzan {
  background-image: url(http://file.chexun.com/chexun/statics/m/news/images/img/dzan.png);
}

.comment-right-span {
  font-size: 10px;
  color: #7889ac;
}

.comment-div1 {
  font-size: 13px;
  color: #344058;
  margin-top: 10px;
  padding-left: 36px;
  line-height: 23px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 7;
  overflow: hidden;
}

.comment-list {
  border-bottom: 1px solid #efefef;
  padding-bottom: 15px;
}

.comment-list:nth-last-child(1) {
  border-bottom: 0;
  padding-bottom: 0;
}

.comment-list:nth-child(1) .comment-div {
  margin-top: 0;
}

.comment-reply {
  padding-left: 36px;
  margin-top: 11px;
}

.comment-reply .comment-div {
  margin-top: 0;
}

.comment-reply .comment-div1 {
  margin-top: 1px;
  padding-left: 0;
}

.comment-reply .comment-div1 span {
  color: #7889ac;
}

.comment-reply .comment-div-img {
  width: 22px;
  height: 22px;
}

.comment-reply .comment-span-name {
  font-size: 11px;
}

.comment-reply .comment-span-time {
  font-size: 9px;
}

.comment-pullRe {
  display: flex;
  align-items: center;
  color: #6c7ea2;
  font-size: 13px;
  padding-left: 27px;
  margin-top: 10px;
}

.comment-pullRe img {
  width: 9px;
  height: 5px;
  margin-left: 4px;
}

.comment-pullcom {
  margin-top: 15px;
}

.comment-limitList {
  height: 515px;
  overflow: hidden;
}

.comment-pullAllList {
  width: 100%;
  height: 38px;
  border-radius: 19px;
  background-color: #f5f5f8;
  display: flex;
  align-items: center;
  justify-content: center;
  /* position: absolute;
  bottom:-2.075rem;
  left: 0; */
}

.comment-pullAllList .comment-pullRe {
  margin-top: 0px;
  padding-left: 0;
}

.videoDetaild-hobby {
  margin-top: 25px;
  padding: 0 15px;
}

.videoDetaild-hobby .comment-h1 {
  margin-top: 0;
  margin-bottom: 11px;
}

.videoDetaild-hobby .hobby-video {
  width: 100%;
  height: 188px;
  border-radius: 8px;
}

.videoDetaild-hobby .vjs-poster {
  border-radius: 8px;
}

.videoDetail-div3 .video-js .vjs-big-play-button {
  width: 34px;
  height: 34px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  border-radius: 50%;
}

.videoDetail-div3 .vjs-big-play-centered .vjs-big-play-button {
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  line-height: 34px;
}

.videoDetail-div3 .vjs-icon-placeholder::before {
  font-size: 20px;
}

.hobbyList-div {
  padding-bottom: 15px;
  border-top: 1px solid #efefef;
  padding-top: 15px;
}

.hobbyList:nth-child(1) .hobbyList-div {
  border-top: rgba(250, 250, 250, 0);
}

.hobbyList-div1 {
  padding-top: 0;
  border-top: 1px solid rgba(250, 250, 250, 0);
}

.hobbyList-div .video-js .vjs-big-play-button {
  border: 1px solid rgba(255, 255, 255, 0.2693);
}

.hobbyList-div-video {
  position: relative;
}

.hobbyList-div-span {
  padding: 3px 5px;
  background-color: rgba(000, 000, 000, 0.496);
  font-size: 10px;
  color: #fff;
  border-radius: 9px;
  display: block;
  position: absolute;
  bottom: 7px;
  right: 4px;
}

.hobbyList-div-h1 {
  margin-top: 10px;
  margin-bottom: 10px;
}

.hobbyList-div-h1 h1 {
  color: #333c4f;
  font-size: 15px;
  font-weight: 500;
  line-height: 21px;
}

.hobbyList-div-info {
  display: flex;
  justify-content: space-between;
}

.hobbyList-info-left figure {
  display: flex;
  align-items: center;
}

.hobbyList-info-img {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-right: 5px;
  flex-shrink: 0;
}

.hobbyList-info-img img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.hobbyList-info-left figure figcaption {
  display: flex;
  align-items: center;
}

.hobbyList-info-left figure figcaption p {
  font-size: 12px;
  color: #7889ac;
  margin-right: 8px;
}

.hobbyList-info-left figure figcaption span {
  display: block;
  font-size: 10px;
  color: #c5c5c5;
  flex-shrink: 0;
}

.hobbyList-info-right {
  display: flex;
  align-items: center;
}

.hobbyList-right-div {
  display: flex;
  align-items: center;
  margin-left: 17px;
}

.hobbyList-right-div .hobbyList-right-img {
  width: 18px;
  height: 14px;
  flex-shrink: 0;
  margin-right: 4px;
}

.hobbyList-right-div .hobbyList-right-img1 {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  margin-right: 4px;
}

.hobbyList-right-div span {
  color: #6c7ea2;
  font-size: 12px;
  flex-shrink: 0;
}

.hobbyList-div-imglist {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.hobbyList-div-imglist img {
  width: 111px;
  height: 61px;
  border-radius: 5px;
}

.hobbyList-div-imglist .hobbyList-div-imglist-div {
  width: 111px;
  height: 61px;
  opacity: 0;
}

.hobbyList-allType .allType-img {
  width: 106px;
  height: 60px;
  border-radius: 5px;
  margin-right: 7px;
  flex-shrink: 0;
}

.allType3-div {
  display: flex;
  margin-bottom: 10px;
}

.allType3-div .hobbyList-div-h1 {
  margin: 0;
}

.videoDetail-bottomTab {
  background-color: #fff;
  padding: 13px 0;
  box-shadow: 0px -8px 5px -5px rgba(236, 236, 236, 0.7);
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: space-around;
  z-index: 9;
}

.bottomTab-left {
  margin-left: 13px;
  flex: 1;
  height: 36px;
  background-color: #f5f5f8;
  border-radius: 18px;
  margin-left: 15px;
}

.bottomTab-left img {
  width: 16px;
  height: 14px;
  margin-left: 21px;
  /* position: absolute;
  top:0;
  bottom: 0;
  margin: auto;
  left: 21px; */
}

.bottomTab-left .bottomTab-left-div {
  height: 100%;
  display: flex;
  align-items: center;
}

.bottomTab-left .bottomTab-left-span {
  display: block;
  font-size: 14px;
  color: #7889ac;
  margin-left: 6px;
  /* position: absolute;
  top:0;
  bottom: 0;
  margin: auto;
  left: 2.6875rem;
  display: flex;
  align-items: center; */
}

.bottomTab-left input {
  outline: none;
  border: 0;
  width: 100%;
  height: 100%;
  background-color: #f5f5f8;
  border-radius: 18px;
  text-indent: 6px;
  font-size: 16px;
}

.bottomTab-left input::-webkit-input-placeholder {
  color: #7889ac;
  font-size: 14px;
}

.bottomTab-left input:-moz-placeholder {
  color: #7889ac;
  font-size: 14px;
}

.bottomTab-left input::-moz-placeholder {
  color: #7889ac;
  font-size: 14px;
}

.bottomTab-left input:-ms-input-placeholder {
  color: #7889ac;
  font-size: 14px;
}

.bottomTab-right {
  display: flex;
  align-items: center;
  margin-left: 12px;
  margin-right: 15px;
}

.bottomTab-right .bottomTab-right-div {
  margin-right: 29px;
  position: relative;
}

.bottomTab-right .bottomTab-right-div:nth-last-child(1) {
  margin-right: 0;
}

.bottomTab-right .bottomTab-right-img {
  width: 22px;
  height: 19px;
  margin: 0 auto;
}

.bottomTab-right .bottomTab-right-img1 {
  width: 22px;
  height: 19px;
  margin: 0 auto;
}

.bottomTab-right .bottomTab-right-img2 {
  width: 19px;
  height: 19px;
  margin: 0 auto;
}

.bottomTab-right .bottomTab-right-img3 {
  width: 18px;
  height: 19px;
  margin: 0 auto;
}

.bottomTab-right .bottomTab-right-div p {
  font-size: 10px;
  color: #6c7ea2;
  text-align: center;
  margin-top: 1px;
}

.bottomTab-right-div span {
  color: #f43b19;
  font-size: 9px;
  position: absolute;
  top: -8.5px;
  left: 17px;
}

.bottomTab-right1 {
  width: 83px;
  height: 30px;
  background-color: #7889ac;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
  margin-right: 13px;
}

.bottomTab-right1 span {
  font-size: 14px;
  color: #fff;
}

.bottomTab-left1 {
  /* width: 15.875rem; */
  display: flex;
  align-items: center;
  text-indent: 0;
}

.videoDetail-bottomTab1 {
  width: 100%;
  justify-content: center;
}

.videoDetail-videoHeader1 .videoContent-div2 {
  border: 1px solid #344058;
  color: #344058;
}

.videoDetail-videoHeader1 .videoContent-div1-div p {
  color: #344058;
}

.videoDetail-videoHeader1 .videoContent-head {
  margin-bottom: 0;
}

.videoContent-article {
  margin-top: 10px;
}

.videoContent-article video {
  width: 100%;
}

.videoContent-article p {
  color: #344058;
  font-size: 15px;
  line-height: 27px;
}

.videoContent-article a {
  color: #344058;
}

.videoContent-article span {
  letter-spacing: 1px;
}

.videoContent-articleTime {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 11px;
  border-bottom: 1px solid #eee;
  margin-top: 15px;
}

.articleTime-left {
  font-size: 10px;
  color: #8692ac;
}

.articleTime-right {
  display: flex;
  align-items: center;
}

.articleTime-right-div {
  display: flex;
  align-items: center;
  margin-left: 18px;
}

.articleTime-right-div .articleTime-right-img {
  width: 14px;
  height: 11px;
  flex-shrink: 0;
  margin-right: 4px;
}

.articleTime-right-div .articleTime-right-img1 {
  width: 12px;
  height: 12px;
  flex-shrink: 0;
  margin-right: 4px;
}

.articleTime-right-div {
  font-size: 12px;
  color: #8692ac;
}

.nut-infiniteloading {
  padding: 0 15px;
}

.videoDetail-videoHeader1 .videoContent-div2 {
  border: 1px solid #344058;
  color: #344058;
}

.videoDetail-videoHeader1 .videoContent-div1-div p {
  color: #344058;
}

.videoDetail-videoHeader1 .videoContent-head {
  margin-bottom: 0;
}

.videoContent-article {
  margin-top: 10px;
}

.videoContent-article p {
  color: #344058;
  font-size: 15px;
  line-height: 27px;
}

.videoContent-article img {
  width: 100% !important;
  margin-top: 8px;
  margin-bottom: 11px;
  height: auto !important;
}

.videoContent-articleTime {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 11px;
  border-bottom: 1px solid rgba(230, 230, 230, 1);
  margin-top: 15px;
}

.articleTime-left {
  font-size: 10px;
  color: #8692ac;
}

.articleTime-right {
  display: flex;
  align-items: center;
}

.articleTime-right-div {
  display: flex;
  align-items: center;
  margin-left: 18px;
}

.articleTime-right-div .articleTime-right-img {
  width: 14px;
  height: 11px;
  flex-shrink: 0;
  margin-right: 4px;
}

.articleTime-right-div .articleTime-right-img1 {
  width: 12px;
  height: 12px;
  flex-shrink: 0;
  margin-right: 4px;
}

.articleTime-right-div {
  font-size: 12px;
  color: #8692ac;
}

.nut-infiniteloading {
  padding: 0 15px;
}

.vjs-paused .vjs-big-play-button,
.vjs-paused.vjs-has-started .vjs-big-play-button {
  display: block;
}

.downLoadApp {
  width: 100%;
  height: 65px;
  background-color: #fff;
  box-shadow: 0px -2px 7px 0px rgba(164, 159, 159, 0.5);
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 10001;
  display: flex;
  justify-content: space-between;
}

.downLoadApp-left {
  display: flex;
  align-items: center;
}

.downLoadApp-right {
  display: flex;
  align-items: center;
}

.downLoadApp-img {
  width: 60px;
  flex-shrink: 0;
  margin-left: 20px;
  margin-right: 2px;
}

.downLoadApp-img1 {
  width: 46px;
  height: auto;
  margin-bottom: 2px;
}

.downLoadApp-left-div p {
  font-size: 11px;
  color: #888;
  line-height: 16px;
}

.downLoadApp-right-div {
  padding: 0 10px;
  height: 27px;
  background-color: rgba(52, 64, 88, 1);
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #fff;
  flex-shrink: 0;
}

.downLoadApp-right-img {
  margin-right: 5px;
  margin-left: 5px;
  width: 12px;
  height: 12px;
  flex-shrink: 0;
}

.videoSwipe-divWhite {
  background: rgba(238, 238, 238, 1);
}

.videoSwipe-div .videoSwipe-h2New {
  font-size: 13px;
  color: rgba(244, 59, 25, 1);
}

.videoSwipe-div .videoSwipe-h2New1 {
  color: rgba(52, 64, 88, 1);
  font-size: 15px;
  margin-bottom: 3px;
  /* font-weight: bold; */
}

.videoSwipe-div .videoSwipe-spanNew {
  background-color: rgba(52, 64, 88, 1);
}

.videoInfo-div3 {
  margin-top: 5px;
  margin-bottom: 15px;
}

.videoInfo-div3-p {
  font-size: 12px;
  color: #7889ac;
  line-height: 17px;
}

.videoInfo-div3-span {
  margin-top: 6px;
  display: block;
  font-size: 10px;
  color: rgba(134, 146, 172, 1);
  line-height: 13px;
}

.hobbyList-div-div {
  width: 100%;
  height: 188px;
  border-radius: 5px;
}

.hobbyList-div-div img {
  width: 100%;
  border-radius: 5px;
  height: 100%;
}

.hobbyList-div-img {
  width: 34px;
  height: 34px;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
}

.wifiTips-div1 {
  width: 230px;
  height: 120px;
  background-color: #fff;
  border-radius: 5px;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
}

.wifiTips-p {
  font-size: 13px;
  color: rgba(120, 137, 172, 1);
  line-height: 18px;
  padding: 0 20px;
  margin-top: 20px;
}

.wifiTips-div2 {
  display: flex;
  align-items: center;
  margin-top: 20px;
  justify-content: space-between;
}

.wifiTips-span {
  width: 85px;
  height: 25px;
  border: 1px solid #ccc;
  font-size: 12px;
  color: #999;
  justify-content: center;
  align-items: center;
  display: flex;
  margin-left: 20px;
  margin-right: 20px;
}

.wifiTips-span1 {
  border: 1px solid #7889ac;
  color: #7889ac;
}

.videoContent-divOpcity {
  opacity: 0;
}

.videoDetail-imgCarousel {
  background-color: rgba(0, 0, 0, 1);
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
}

.videoDetail-imgCarousel .nut-swiper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  height: auto;
}

.ImgSwiper {
  width: 100%;
  flex-shrink: 0;
  min-height: 200px;
}

.ImgSwiper img {
  width: 100%;
  height: auto;
}

.videoDetail-imgCarousel .nut-swiper .nut-swiper-wrap {
  align-items: center;
}

.imgCarousel-div1 {
  width: 100%;
  display: flex;
  overflow-x: scroll;
  align-items: center;
}

.imgCarousel-div2 {
  width: 100%;
  flex-shrink: 0;
  /* margin-right: 2%; */
}

/* .imgCarousel-div2:nth-child(1) {
  padding-left: 2%;
} */

.imgCarousel-div2 img {
  width: 100%;
  height: auto;
}

.app-zzSpan {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 8;
  position: fixed;
  top: 0;
  left: 0;
}

.videoDetail-wifiTips {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 100;
}

.app-testSpan {
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 99999;
}

.statusHeight {
  width: 100%;
  height: auto;
}

.app-scroller {
  width: 100%;
  height: 200px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9;
  /* background-color: rgba(255, 255, 255, 0.5); */
}

.nut-vert-pulldown-txt {
  opacity: 0;
}

.pullTips {
  width: 100%;
  height: 60px;
  text-align: center;
  line-height: 70px;
  font-size: 12px;
  color: #7889ac;
  transition: all linear 0.5s;
}

.pullTips1 {
  width: 100%;
  height: 0px;
  text-align: center;
  line-height: 70px;
  font-size: 12px;
  color: #7889ac;
  transition: all linear 0.5s;
}

.tcDiv {
  width: 100%;
  height: auto;
  background-color: #fff;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 7;
}

.loadPage {
  width: 100%;
  height: 100%;
  z-index: 99999;
  background-color: #fff;
  position: fixed;
  top: 0;
  left: 0;
}

.loadPage img {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 40px;
}

.vjs-has-started .vjs-control-bar {
  align-items: center !important;
}

.cxTag1 {
  width: 100%;
  height: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
}

.cxTag {
  /* width: 100%;
  height: 300%;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 10000; */
  width: 100%;
  height: 300px;
  position: fixed;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
}

.cxTag-content {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  background-color: #fff;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 10000;
  border-radius: 15px 15px 0 0;
}

.cxTag-div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 14px;
}

.cxTag-div h1 {
  font-size: 14px;
  margin-left: 15px;
  color: rgba(52, 64, 88, 1);
}

.cxTag-div img {
  width: 12px;
  height: 12px;
  margin-right: 15px;
}

.cxTag-div1 {
  padding: 0 15px;
  margin-top: 13px;
}

.cxTag-div1 .nut-swiper.horizontal .nut-swiper-pagination {
  bottom: 0;
  z-index: -1;
}

.cxTag-div1 .nut-swiper {
  height: 124px;
  overflow: unset;
  overflow-x: hidden;
}

.cxTag-div1 .nut-swiper .nut-swiper-pagination .swiper-pagination-bullet {
  width: 8px;
  height: 2px;
  background-color: #dfdfdf;
  border-radius: 1px;
}

.cxTag-div1 .nut-swiper .nut-swiper-pagination .swiper-pagination-bullet.active {
  width: 12px;
  background-color: #333333;
  border-radius: 1px;
}

.cxTag-div2 {
  padding: 0 15px;
  margin-top: 14px;
}

.cxTag-div2-div {
  display: flex;
  align-items: center;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(230, 230, 230, 1);
  margin-bottom: 10px;
}

.cxTag-div2-img {
  width: 72px;
  height: 48px;
  border-radius: 3px;
}

.cxTag-div2-div1 {
  flex: 1;
  margin-left: 9px;
}

.cxTag-div2-h1 {
  font-size: 13px;
  color: rgba(18, 24, 38, 1);
  margin-bottom: 3px;
}

.cxTag-div2-h2 {
  color: rgba(250, 108, 82, 1);
  font-size: 12px;
  font-weight: 500;
}

.cxTag-div2-div2 {
  width: 83px;
  height: 32px;
  border-radius: 5px;
  border: 1px solid #f7d7d1;
  font-size: 12px;
  color: #f43b19;
  display: flex;
  align-items: center;
  justify-content: center;
}

.vjs-modal-dialog-content {
  display: none;
}

.vjs-error .vjs-error-display:before {
  content: "";
}

.video-js .vjs-modal-dialog {
  /* display: none; */
}
</style>
